import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import ErrorBoundary from './ui/ErrorBoundary';
import { registerServiceWorker } from '@/offline/sw-register';
import './ui/styles.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root element missing');

// Offline shell: register the service worker (production build only — in
// `npm run dev` this module never registers and unregisters anything stale,
// see src/offline/sw-register.ts for the guarantee).
registerServiceWorker();

// Outer boundary: whatever crashes inside, the GM still gets the recovery
// panel (download the campaign / reload) instead of a white screen. The
// inner boundary around the route switch lives in App.tsx.
createRoot(rootEl).render(
  <ErrorBoundary>
    <StrictMode>
      <App />
    </StrictMode>
  </ErrorBoundary>,
);
